<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item">
                <div class="custom-toolbar">
                    <div class="custom-toolbar-start">
                        <TeamMemberDocumentsReportFilter
                            :class="$root.isTablet ? 'tablet-filter-container' : ''"
                            @changed="handleFilterOrSearch"
                            :team-members="() => this.teamMembers"
                            :team-region-id="filters.teamRegionId"
                            :filter-value="filters"
                        />
                    </div>
                    <div class="custom-toolbar-end">
                        <md-button
                            title="Export Stops report"
                            class="md-primary md-just-icon md-round pull-right header-button"
                            @click="onExportToExcel"
                        >
                            <md-icon>get_app</md-icon>
                        </md-button>
                    </div>
                </div>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>fact_check</md-icon>
                        </div>
                    </md-card-header>

                    <md-card-content>
                        <div v-if="!reports || reports.length == 0">
                            <h3>Documents</h3>
                            <p>
                                No results to display.
                            </p>
                        </div>
                        <div v-else>
                            <div class="report-container">
                                <md-card-content>
                                    <TeamMemberDocumentReportMatrix :reports="reports" />
                                </md-card-content>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions v-if="total" class="page-footer" md-alignment="space-between">
                        <div>
                            <p v-if="total === pagination.perPage" class="card-category">
                                Page {{ pagination.currentPage }} of many
                            </p>
                            <p v-else class="card-category">Page {{ pagination.currentPage }} of {{ totalPages }}</p>
                        </div>
                        <Pagination
                            v-model="pagination.currentPage"
                            class="pagination-no-border pagination-success"
                            :per-page="pagination.perPage"
                            :total="total"
                            :enable-first-page-link="true"
                            :enable-last-page-link="true"
                            @change-page="handleChangePage($event, pagination.perPage)"
                        />
                    </md-card-actions>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { Pagination } from '@/components';
import { mapGetters, mapActions } from 'vuex';
import { handleRequests, downloadFile } from '../../helpers';
import TeamMemberDocumentsReportFilter from './components/TeamMemberDocumentsReportFilter';
import TeamMemberDocumentReportMatrix from './components/TeamMemberDocumentReportMatrix';

export default {
    name: 'TeamMemberDocumentsReport',
    components: { Pagination, TeamMemberDocumentsReportFilter, TeamMemberDocumentReportMatrix },
    mixins: [GeneralMixin],
    data() {
        return {
            reports: [],
            pagination: {
                perPage: 15,
                currentPage: 1,
                total: 0
            },
            filters: {
                teamRegionId: null,
                publicUserId: null,
                dateFrom: null,
                dateTo: null,
                documentGroup: null
            }
        };
    },
    computed: {
        ...mapGetters({
            teamMembers: 'team/teamMembers'
        }),
        total() {
            return this.pagination.total;
        },
        totalPages() {
            if (this.total > 0) {
                return Math.ceil(this.total / this.pagination.perPage);
            }
            return 1;
        }
    },

    methods: {
        ...mapActions('team', ['FETCH_TEAM_MEMBERS']),
        async getReports() {
            this.$_handleLoaderState(true);

            const endpoint = '/api/reports/team-member-documents';

            await handleRequests(endpoint, {
                method: 'post',
                data: this.getPayload()
            })
                .then((response) => {
                    const { data, total } = response.data;

                    this.reports = data;
                    this.pagination.total = total;
                })
                .catch((err) => {
                    this.$notify({
                        message: 'Error retrieving reports.',
                        type: 'danger'
                    });
                })
                .finally(() => {
                    this.$_handleLoaderState(false);
                });
        },
        async handleChangePage(currentPage = 1, perPage = 15) {
            this.pagination.currentPage = currentPage;
            this.pagination.perPage = perPage;

            await this.getReports();
        },
        getPayload() {
            return {
                teamRegionId: this.filters.teamRegionId,
                publicUserId: this.filters.publicUserId || '',
                dateFrom: this.filters.dateFrom || null,
                dateTo: this.filters.dateTo || null,
                documentGroup: this.filters.documentGroup || '',
                pageNumber: this.pagination.currentPage,
                itemsPerPage: this.pagination.perPage
            };
        },
        onExportToExcel() {
            this.$_handleLoaderState(true);
            const endpoint = '/api/reports/team-member-documents/export-to-excel';
            handleRequests(endpoint, {
                method: 'post',
                data: { ...this.getPayload(), pageNumber: null, itemsPerPage: null },
                responseType: 'blob'
            })
                .then((response) => {
                    downloadFile(response.data, 'reportName.xlsx');
                })
                .catch((e) => {
                    this.$notify({ message: 'Error generating reports.', type: 'danger' });
                })
                .finally(() => this.$_handleLoaderState(false));
        },
        async handleFilterOrSearch(val) {
            this.pagination.currentPage = 1;

            this.filters = Object.assign(this.filters, {
                teamRegionId: val.teamRegionId,
                publicUserId: val.teamMemberPublicUserId,
                dateFrom: val.fromDate,
                dateTo: val.toDate,
                documentGroup: val.documentGroup
            });
            await this.getReports();
        }
    },
    async mounted() {
        this.FETCH_TEAM_MEMBERS();
        this.getReports();
    }
};
</script>

<style lang="scss" scoped>
.custom-toolbar {
    align-items: start;
    margin-top: 1px;
    .custom-toolbar-start {
        flex: 3;
    }
}

.header-button {
    width: 32px;
    height: 32px;
    min-width: 32px;
}

::v-deep .filter-steps--container {
    // width: 880px;
    margin-top: 6px;
    // float: right;

    .filter-steps--choices {
        margin-top: 0;
        padding-bottom: 0;
        > .md-input {
            display: initial;
        }
    }
}
</style>
